// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"3cee3f72","233":"148a7650","305":"342de982","367":"d4bff512","420":"f3a27dde","451":"b89a6806","458":"f5c29b5f","492":"c323ab0a","558":"0fb67ec4","629":"760c2d32","655":"d1d16056","756":"33c2a91f","821":"57ff0dec","972":"bdf11e12"}[chunkId] + ".chunk.js";
};